import { TrialRegionActionsCreators, TrialRegionActionType } from './types/actions';

const trialRegionActionsCreators: TrialRegionActionsCreators = {
  fetchTrialRegions: () => ({
    type: TrialRegionActionType.FetchTrialRegions,
  }),
  fetchTrialRegionsRejected: (error) => ({
    type: TrialRegionActionType.FetchTrialRegionsRejected,
    payload: { error },
  }),
  fetchTrialRegionsResolved: (trialRegion) => ({
    type: TrialRegionActionType.FetchTrialRegionsResolved,
    payload: trialRegion,
  }),
};

export default trialRegionActionsCreators;
